export default __webpack_public_path__ + "static/media/etanol.a5a7bed5.jpg";